// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1mISt{opacity:.1}._1mISt,.t4Y93{fill:transparent;stroke:#30a8ff}.t4Y93{opacity:.3}._1TToc{fill:transparent;stroke:#30a8ff;-webkit-transform:rotate(-90deg);-ms-transform:rotate(-90deg);transform:rotate(-90deg);-webkit-transform-origin:50% 50%;-ms-transform-origin:50% 50%;transform-origin:50% 50%;-webkit-transition:stroke-dashoffset .3s;transition:stroke-dashoffset .3s}.rRCxy{fill:#30a8ff;font-weight:800}._36Mp4{height:50px;height:5rem;stroke:#30a8ff;stroke-width:4px;width:50px;width:5rem}._3seev{fill:transparent;stroke:#30a8ff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;-webkit-transition:stroke-dashoffset .5s ease-out;transition:stroke-dashoffset .5s ease-out}", ""]);
// Exports
exports.locals = {
	"backgroundCircle": "_1mISt",
	"pathCircle": "t4Y93",
	"progressCircle": "_1TToc",
	"percentText": "rRCxy",
	"startIcon": "_36Mp4",
	"tick": "_3seev"
};
module.exports = exports;
